import constants from './CommonConstants';

// eslint-disable-next-line import/prefer-default-export
export const ENTITY_LEVELS_WITH_SAVABLE_FILTERS = [
  constants.ORGANIZATION_LEVEL,
  constants.ACCOUNT_LEVEL,
  constants.PIPELINE_LEVEL,
  constants.CONTACT_LEVEL,
  constants.TASK_LEVEL,
  constants.SUCCESS_PLAN_LEVEL,
  constants.OPPORTUNITY_LEVEL,
  constants.RISK_LEVEL,
];

export const FILTERED_VIEW_VISIBILITY = {
  PUBLIC: 'public',
  PRIVATE: 'private',
};

export const MAX_FILTERED_VIEW_COUNT = 15;
